<div class="esf-accordion__unit">
  <div class="esf-accordion__trigger -is-open">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
      <span class="esf-action-heading__text" i18n='Section title@@club.heading.webhookSettings'>Webhook Settings</span>
      <span class="esf-action-heading__actions">
        <span class="esf-action-heading__action">

          <button class="esf-button esf-button--simple"
                  (click)="clubOverviewService.toggleAllModal(false);clubOverviewService.togleEditWebhooksModal(true);$event.stopPropagation();"
                  [disabled]="selectedClub?.webhooks?.length === 0"
                  [edsTooltip]="tooltipTranslations.i18nEdit">
            <svg class="esf-icon esf-button__icon" width="16" height="16">
              <use xlink:href="#esf-icon-edit"></use>
            </svg>
            <span class="esf-button__icon-text"></span>
          </button>

        </span>
      </span>
    </h4>
  </div>
  <div class="esf-accordion__target -is-open">

    <div class="esf-info-tile esf-info-tile--full-width">
      <div class="esf-info-tile__content">

        <table class="esf-table" *ngIf="selectedClub?.webhooks?.length">
          <thead class="esf-table__head">
            <tr class="esf-table__row">
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.webhook' data-label="Webhook">
                <span i18n='Table cell heading@@general.tableCellLabel.webhook' class="esf-table__cell-inner">Webhook</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.status' data-label="Status">
                <span i18n='Table cell heading@@general.tableCellLabel.status' class="esf-table__cell-inner">Status</span>
              </th>
            </tr>
          </thead>
          <tbody class="esf-table__body">
            <tr class="esf-table__row" *ngFor="let webhook of selectedClub.webhooks">
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.webhook' data-label="Webhook">
                <span class="esf-table__cell-inner">{{ webhook.translatedName }}</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.status' data-label="Status">
                <span class="esf-table__cell-inner" [ngClass]="{active: webhook.status === 'active',
                      inactive: webhook.status === 'inactive'}">{{ webhook.translatedStatus }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <section class="esf-empty-state flex-empty-state" *ngIf="selectedClub?.webhooks?.length === 1" style="margin-top: 20px">
          <button class="esf-button esf-button--standard esf-button--filled esf-button--small" (click)="clubOverviewService.togleCreateWebhooksModal(true)">
            <svg class="esf-icon esf-button__icon" width="16" height="16">
              <use xlink:href="#esf-icon-plus"></use>
            </svg>
            <span class="esf-button__icon-text" i18n='Button for empty state@@customerOverviewComponent.button.addNewWebhook'>Add a new webhook</span>
          </button>
        </section>

        <table class="esf-table" *ngIf="!selectedClub?.webhooks?.length">
          <section class="esf-empty-state flex-empty-state">
            <div>
              <svg class="esf-icon esf-empty-state__icon" width="32" height="32">
                <use xlink:href="#esf-icon-globe"></use>
              </svg>
            </div>
            <p class="esf-paragraph"><small i18n='Text for empty state@@customerOverviewComponent.text.noWebhooks'>There are no webhooks yet.</small></p>
            <button class="esf-button esf-button--standard esf-button--filled esf-button--small" (click)="clubOverviewService.togleCreateWebhooksModal(true)">
              <svg class="esf-icon esf-button__icon" width="16" height="16">
                <use xlink:href="#esf-icon-plus"></use>
              </svg>
              <span class="esf-button__icon-text" i18n='Button for empty state@@customerOverviewComponent.button.addNewWebhook'>Add a new webhook</span>
            </button>
          </section>
        </table>

      </div>
    </div>
  </div>
</div>
